import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type EditGroupRows = {
  label: vp.GroupCreationLabel;
  id: vp.GroupCreationId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
  type: 'input';
  getSelectOptions: () => { [key: string]: string };
};

export const buildEditGroupRows = (): EditGroupRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Create.Form' });
  return [
    {
      label: t('GroupName.label'),
      id: vp.GroupCreationId.GroupName,
      require: true,
      preset: 'text',
      type: 'input',
      getSelectOptions: () => ({}),
    },
    {
      label: t('Description.label'),
      id: vp.GroupCreationId.Description,
      require: true,
      preset: 'text',
      type: 'input',
      getSelectOptions: () => ({}),
    },
    {
      label: t('Service.label'),
      id: vp.GroupCreationId.Service,
      require: false,
      preset: 'text',
      type: 'input',
      getSelectOptions: () => ({}),
    },
    {
      label: t('Currency.label'),
      id: vp.GroupCreationId.Currency,
      require: false,
      preset: 'text',
      type: 'input',
      getSelectOptions: () => ({}),
    },
  ];
};
